
import cx from 'classnames';

import './styles.css';

type Props = {
  cep: string;
  street: string;
  neighborhood: string;
  state: string;
  showIconAdd?: boolean;
  onClick?(): void;
};

const AddressCard = ({
  cep,
  street,
  neighborhood,
  state,
  onClick,
  showIconAdd = false,
}: Props) => {
  return (
    <button
      type='button'
      onClick={onClick && onClick}
      className={cx(
        'flex w-full cursor-default items-center justify-start rounded-lg border border-gray-500 py-2 pl-4 focus:border-0',
        {
          'cursor-pointer': !!onClick,
          'addressCard ': !!onClick,
        },
      )}
    >
      <img src='/map-pin.svg' alt='Map pin' />
      <div className='ml-3 flex w-full flex-col items-start space-y-2 text-tim-primary'>
        <span className='font-bold'>{street}</span>
        <span>
          {neighborhood} - {state}
        </span>
        <span>CEP: {cep}</span>
      </div>
      {showIconAdd && (
        <img
          src='/add-circle-outline.svg'
          className='mr-2 max-h-10'
          alt='add'
        />
      )}
    </button>
  );
};

export default AddressCard;
